export const NavbarData = [
  {
    title: "Hire",
    path: "/hire",
    cName: "nav-links",
  },
  {
    title: "Jobs",
    path: "/jobs",
    cName: "nav-links",
  },
  {
    title: "Explore Portfolios",
    path: "/explore",
    cName: "nav-links",
  },
];

export const Skills = [
  "NFT",
  "3D Environment",
  "Interaction Design",
  "Simulation",
  "Digital twin",
  "Unreal Experience",
];

export const dateJSON = {
  Jan: {
    name: "January",
    short: "Jan",
    number: 1,
    days: 31,
  },
  Feb: {
    name: "February",
    short: "Feb",
    number: 2,
    days: 28,
  },
  Mar: {
    name: "March",
    short: "Mar",
    number: 3,
    days: 31,
  },
  Apr: {
    name: "April",
    short: "Apr",
    number: 4,
    days: 30,
  },
  May: {
    name: "May",
    short: "May",
    number: 5,
    days: 31,
  },
  Jun: {
    name: "June",
    short: "Jun",
    number: 6,
    days: 30,
  },
  Jul: {
    name: "July",
    short: "Jul",
    number: 7,
    days: 31,
  },
  Aug: {
    name: "August",
    short: "Aug",
    number: 8,
    days: 31,
  },
  Sep: {
    name: "September",
    short: "Sep",
    number: 9,
    days: 30,
  },
  Oct: {
    name: "October",
    short: "Oct",
    number: 10,
    days: 31,
  },
  Nov: {
    name: "November",
    short: "Nov",
    number: 11,
    days: 30,
  },
  Dec: {
    name: "December",
    short: "Dec",
    number: 12,
    days: 31,
  },
};

export const getMonthName = [
  {
    name: "January",
    id: 1,
    short: "Jan",
  },
  {
    name: "February",
    id: 2,
    short: "Feb",
  },
  {
    name: "March",
    id: 3,
    short: "Mar",
  },
  {
    name: "April",
    id: 4,
    short: "Apr",
  },
  {
    name: "May",
    id: 5,
    short: "May",
  },
  {
    name: "June",
    id: 6,
    short: "Jun",
  },
  {
    name: "July",
    id: 7,
    short: "Jul",
  },
  {
    name: "August",
    id: 8,
    short: "Aug",
  },
  {
    name: "September",
    id: 9,
    short: "Sep",
  },
  {
    name: "October",
    id: 10,
    short: "Oct",
  },
  {
    name: "November",
    id: 11,
    short: "Nov",
  },
  {
    name: "December",
    id: 12,
    short: "Dec",
  },
];
